import React from 'react';

// Discord webhook name/URL inputs (Edit View)
export function DiscordWebhookForm({ webhookName, setWebhookName, webhookUrl, setWebhookUrl }) {
    return (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden p-6 space-y-4">
            <div>
                <label htmlFor="webhook-name" className="block text-sm font-medium text-gray-700 mb-1">Webhook Name</label>
                <input
                    id="webhook-name"
                    type="text"
                    className="w-full border-gray-300 rounded-lg px-4 py-2 border focus:ring-2 focus:ring-blue-500 outline-none"
                    placeholder="e.g. #general updates"
                    value={webhookName}
                    onChange={e => setWebhookName(e.target.value)}
                />
            </div>
            <div>
                <label htmlFor="webhook-url" className="block text-sm font-medium text-gray-700 mb-1">Webhook URL</label>
                <input
                    id="webhook-url"
                    type="text"
                    className="w-full border-gray-300 rounded-lg px-4 py-2 border focus:ring-2 focus:ring-blue-500 outline-none"
                    placeholder="https://discord.com/api/webhooks/..."
                    value={webhookUrl}
                    onChange={e => setWebhookUrl(e.target.value)}
                />
                <p className="text-xs text-gray-400 mt-2">
                    Go to Server Settings &gt; Integrations &gt; Webhooks to create one.
                </p>
            </div>
        </div>
    );
}
